// Theme-aware color palettes for the pull-to-refresh scenes. Layer shades go
// from backdrop (deepest) to ground (closest to the viewer); `text` doubles
// as the color for thin line props, the label, and the hero icon; `accent`
// is the release-burst color. Hexes are starting points — tune visually in
// /admin/refresh-scenes. A scene may add its own extra shade (mushing uses
// `glow`: the sun by day, the northern lights by night).

import {
    SCENE_MARKSMAN, SCENE_VET_DOG, SCENE_RUNNER, SCENE_MUSHING, SCENE_PAPER_PLANE,
} from './pickScene';

export const PALETTES = {
    [SCENE_MARKSMAN]: {
        accent: '#ffc107',
        dark: { backdrop: '#0f141b', sky: '#2c3a49', far: '#243447', mid: '#33495f', ground: '#415d79', text: '#9fb3c8' },
        light: { backdrop: '#dce8f5', sky: '#ffffff', far: '#b9cde2', mid: '#90aecb', ground: '#6488ab', text: '#41597a' },
    },
    [SCENE_VET_DOG]: {
        accent: '#ff6b81',
        dark: { backdrop: '#0e1712', sky: '#283b31', far: '#20342a', mid: '#2f4a3c', ground: '#3d5f4d', text: '#a3c2b2' },
        light: { backdrop: '#ddf0e6', sky: '#ffffff', far: '#b5d6c5', mid: '#8bbca4', ground: '#619b7f', text: '#3c6b54' },
    },
    [SCENE_RUNNER]: {
        accent: '#ff5252',
        dark: { backdrop: '#1a1210', sky: '#3d2b23', far: '#33241d', mid: '#4a332a', ground: '#5f4436', text: '#c8ab9f' },
        light: { backdrop: '#f7e3d8', sky: '#ffffff', far: '#e0bda9', mid: '#c99878', ground: '#a97253', text: '#7a4b30' },
    },
    [SCENE_MUSHING]: {
        accent: '#e03131',
        dark: { backdrop: '#070d1c', sky: '#dfe8f5', far: '#18253b', mid: '#1f3148', ground: '#34486a', text: '#c6d4e6', glow: '#4cf2a4' },
        light: { backdrop: '#d6e6f5', sky: '#ffffff', far: '#b3c7dc', mid: '#58766a', ground: '#e8eff6', text: '#2c4257', glow: '#ffc94d' },
    },
    [SCENE_PAPER_PLANE]: {
        accent: '#4dabf7',
        dark: { backdrop: '#0d1520', sky: '#2b3c52', far: '#233348', mid: '#324a66', ground: '#425e80', text: '#a2b8d0' },
        light: { backdrop: '#dceafb', sky: '#ffffff', far: '#b7cfec', mid: '#8db2d9', ground: '#6390bd', text: '#3f5f85' },
    },
};

export function getPalette(sceneId, dark) {
    const scenePalette = PALETTES[sceneId] || PALETTES[SCENE_PAPER_PLANE];
    const shades = dark ? scenePalette.dark : scenePalette.light;
    return { ...shades, accent: scenePalette.accent };
}
